export var Sizing;
(function (Sizing) {
    Sizing["u0"] = "0";
    Sizing["u05"] = "0.4rem";
    Sizing["u1"] = "0.8rem";
    Sizing["u2"] = "1.6rem";
    Sizing["u3"] = "2.4rem";
    Sizing["u4"] = "3.2rem";
    Sizing["u5"] = "4rem";
    Sizing["u6"] = "4.8rem";
    Sizing["u7"] = "5.6rem";
    Sizing["u8"] = "6.4rem";
    Sizing["u9"] = "7.2rem";
    Sizing["u10"] = "8rem";
})(Sizing || (Sizing = {}));
